import { createContext } from 'preact';
const ConfigContext = createContext({});
export default ConfigContext;